import AutoSavingAction from '../actions/AutoSavingAction';

export enum AutoSavingState {
  Disabled,
  Idle,
  RunningForLatestVersion,
  RunningForOldVersion,
}

export function applyModification(state: AutoSavingState): AutoSavingState {
  switch (state) {
    case AutoSavingState.Disabled:
      return state;

    case AutoSavingState.Idle:
      return AutoSavingState.RunningForLatestVersion;

    case AutoSavingState.RunningForLatestVersion:
      return AutoSavingState.RunningForOldVersion;

    case AutoSavingState.RunningForOldVersion:
      return state;
  }
}

export function isAutoSavingRunning(state: AutoSavingState) {
  switch (state) {
    case AutoSavingState.RunningForLatestVersion:
    case AutoSavingState.RunningForOldVersion:
      return true;

    default:
      return false;
  }
}

export function didAutoSavingStart(prevState: AutoSavingState, state: AutoSavingState) {
  return (prevState === AutoSavingState.Idle && state === AutoSavingState.RunningForLatestVersion);
}

export function didAutoSavingRestart(prevState: AutoSavingState, state: AutoSavingState) {
  return (prevState === AutoSavingState.RunningForOldVersion
    && state === AutoSavingState.RunningForLatestVersion);
}

export function didAutoSavingEnd(prevState: AutoSavingState, state: AutoSavingState) {
  return (prevState === AutoSavingState.RunningForLatestVersion && state === AutoSavingState.Idle);
}

export default function autoSaving(
  state: AutoSavingState,
  action: AutoSavingAction.Action,
): AutoSavingState {
  switch (action.type) {
    case AutoSavingAction.ActionType.ENABLE:
      switch (state) {
        case AutoSavingState.Disabled:
          return AutoSavingState.Idle;

        default:
          break;
      }

      return state;

    case AutoSavingAction.ActionType.FINISH_PROCESS:
      switch (state) {
        case AutoSavingState.RunningForLatestVersion:
          return AutoSavingState.Idle;

        case AutoSavingState.RunningForOldVersion:
          return AutoSavingState.RunningForLatestVersion;

        default:
          break;
      }

      throw new Error('Illegal state.');
  }
}
